<script lang="ts">
	import { _ } from 'svelte-i18n';
	import Icon from '../Icon.svelte';

	interface Props {
		id?: string | null;
		value?: string | null;
		placeholder?: string | null;
		propertyName: string;
		disabled?: boolean;
		errors?: any;
		onBlur?: (e: { currentTarget: HTMLInputElement }) => void;
		onKeyup?: (e: KeyboardEvent & { currentTarget: HTMLInputElement }) => void;
		onKeydown?: (e: KeyboardEvent & { currentTarget: HTMLInputElement }) => void;
	}

	let {
		id = null,
		value = $bindable(''),
		placeholder = null,
		propertyName,
		disabled = false,
		errors = {},
		onBlur = undefined,
		onKeydown = undefined,
		onKeyup = undefined
	}: Props = $props();

	let type: string = $state('password');

	function handleInput(event: Event) {
		const target = event.target as HTMLInputElement;

		//Map it to a normal string
		value = target.value;
	}

	function switchInputType() {
		if (type === 'password') {
			type = 'text';
		} else {
			type = 'password';
		}
	}
</script>

<div>
	<div class="relative">
		<input
			{id}
			data-testid={propertyName}
			{type}
			autocomplete="current-password"
			{disabled}
			oninput={handleInput}
			onblur={onBlur}
			{value}
			onkeydown={onKeydown}
			onkeyup={onKeyup}
			{placeholder}
		/>

		<button class="absolute right-2 top-0 bottom-0" onclick={switchInputType} tabindex="-1">
			<div class="grid justify-center text-disabled">
				<Icon name="eye" classInfo="dark:fill-secondary-500" />
			</div>
		</button>
	</div>

	{#if errors[propertyName]}
		<p class="text-red dark:text-orange text-sm">{errors[propertyName]}</p>
	{/if}
</div>
